/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Wealthlane_AwardService_Dtos_TransferAgents_ActiveTransferAgentIntegrationDto } from '../models/Wealthlane_AwardService_Dtos_TransferAgents_ActiveTransferAgentIntegrationDto';
import type { Wealthlane_AwardService_Dtos_TransferAgents_CreateUpdateTransferAgentIntegrationDto } from '../models/Wealthlane_AwardService_Dtos_TransferAgents_CreateUpdateTransferAgentIntegrationDto';
import type { Wealthlane_AwardService_Dtos_TransferAgents_TransferAgentIntegrationDto } from '../models/Wealthlane_AwardService_Dtos_TransferAgents_TransferAgentIntegrationDto';
import type { Wealthlane_Shared_Hosting_Dtos_GenericApiResponse } from '../models/Wealthlane_Shared_Hosting_Dtos_GenericApiResponse';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class TransferAgentIntegrationService {

    /**
     * @param requestBody
     * @returns Wealthlane_Shared_Hosting_Dtos_GenericApiResponse OK
     * @throws ApiError
     */
    public static postApiAwardApiAppTransferAgent(
        requestBody?: Wealthlane_AwardService_Dtos_TransferAgents_CreateUpdateTransferAgentIntegrationDto,
    ): CancelablePromise<Wealthlane_Shared_Hosting_Dtos_GenericApiResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/award/api/app/transfer-agent',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @returns Wealthlane_AwardService_Dtos_TransferAgents_TransferAgentIntegrationDto OK
     * @throws ApiError
     */
    public static getApiAwardApiAppTransferAgent(): CancelablePromise<Wealthlane_AwardService_Dtos_TransferAgents_TransferAgentIntegrationDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/transfer-agent',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param id
     * @param requestBody
     * @returns Wealthlane_Shared_Hosting_Dtos_GenericApiResponse OK
     * @throws ApiError
     */
    public static putApiAwardApiAppTransferAgent(
        id: string,
        requestBody?: Wealthlane_AwardService_Dtos_TransferAgents_CreateUpdateTransferAgentIntegrationDto,
    ): CancelablePromise<Wealthlane_Shared_Hosting_Dtos_GenericApiResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/award/api/app/transfer-agent/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param id
     * @param isActive
     * @returns Wealthlane_Shared_Hosting_Dtos_GenericApiResponse OK
     * @throws ApiError
     */
    public static postApiAwardApiAppTransferAgentSetTAIntegrationStatus(
        id: string,
        isActive?: boolean,
    ): CancelablePromise<Wealthlane_Shared_Hosting_Dtos_GenericApiResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/award/api/app/transfer-agent/{id}/set-tAIntegration-status',
            path: {
                'id': id,
            },
            query: {
                'isActive': isActive,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param id
     * @returns Wealthlane_Shared_Hosting_Dtos_GenericApiResponse OK
     * @throws ApiError
     */
    public static postApiAwardApiAppTransferAgentRotateSecurityKeys(
        id: string,
    ): CancelablePromise<Wealthlane_Shared_Hosting_Dtos_GenericApiResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/award/api/app/transfer-agent/{id}/rotate-security-keys',
            path: {
                'id': id,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @returns boolean OK
     * @throws ApiError
     */
    public static postApiAwardApiAppTransferAgentIsAnyTransferAgentIntegrationActive(): CancelablePromise<boolean> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/award/api/app/transfer-agent/is-any-transfer-agent-integration-active',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @returns Wealthlane_AwardService_Dtos_TransferAgents_ActiveTransferAgentIntegrationDto OK
     * @throws ApiError
     */
    public static getApiAwardApiAppTransferAgentActiveTransferAgentIntegration(): CancelablePromise<Wealthlane_AwardService_Dtos_TransferAgents_ActiveTransferAgentIntegrationDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/transfer-agent/active-transfer-agent-integration',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

}
